import React from 'react';

import './index.css';

const Component = () => {
    return (
        <div className="row footer">
            <p>&copy; PLANR Lab, {new Date().getFullYear()}.</p>
        </div>
    );
};

export default Component;
